import {CapacityResponse} from '../api/types/types';

const capacityCache = new Map<string, CapacityResponse>();

export {capacityCache};
